import { useEffect, useRef, useState } from 'react'

interface Props {
  id: string
}

export function useSkillHandler({ id }: Props) {
  const $skillRef = useRef<HTMLIFrameElement>(null)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    const f = ({ data, source }: MessageEvent) => {
      const isSkillIframe = source === $skillRef.current?.contentWindow
      if (data?.__krkr__ && data.type === 'resize' && (data._id === id || isSkillIframe)) {
        setHeight(data.height)
      }
    }
    window.addEventListener('message', f)
    return () => {
      window.removeEventListener('message', f)
    }
  }, [id])

  return {
    $skillRef,
    height,
  }
}
